import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreDirectives } from '@core/directives/core.directives';

import { CoreModule } from '@core/core.module';
import { CoreStorageModule } from '@core/components/storage/storage.module';

import { ProfileAvatarMainComponent } from './main/main.component';
import { ProfileAvatarEditComponent } from './edit/edit.component';
import { ProfileAvatarUploadComponent } from './upload/upload.component';

/**
 * @deprecated we should use new app version since 12/10/2026
 */
@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        CoreModule,
        CoreDirectives,
        CoreStorageModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProfileAvatarMainComponent,
        ProfileAvatarEditComponent,
        ProfileAvatarUploadComponent
    ],
    exports: [
		ProfileAvatarMainComponent,
        ProfileAvatarEditComponent,
        ProfileAvatarUploadComponent
	],

})
export class ProfileAvatarModule { }
